const hasOwnProperty = Object.prototype.hasOwnProperty
const getPrototype = Object.getPrototypeOf
const funcToString = Function.prototype.toString
const objectCtorString = funcToString.call(Object)

export interface ComponentIs {
  is: boolean
}

export function forceRender(component: ComponentIs, vue) {
  component.is = false
  vue.$nextTick(() => {
    component.is = true
  })
}

export function removeUndefinedValues(obj, ignoreProp: string = undefined): any {
  for (const prop in obj) {
    if (ignoreProp && prop === ignoreProp) {
    } else if (typeof obj[prop] === 'object' && obj[prop] !== null) {
      removeUndefinedValues(obj[prop]) // Recursively check nested objects
    } else if (obj[prop] === undefined) {
      delete obj[prop] // Delete properties with undefined value
    }
  }
  return obj
}

export function isValidURL(url: string, http: boolean = false) {
  const urlPattern = (http)
    ? /^https?:\/\/(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/
    : /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?$/

  return urlPattern.test(url.replace('www.', ''))
}

//DeepClone
export function jsonClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

//DeepClone
export function assignClone(obj) {
  return Object.assign({}, obj)
}

export function isDef(v) {
  return v !== undefined && v !== null
}

export function noop() {
}

export function localStringToNumber(val) {
  return Number(val.replaceAll(',', ''))
}

export function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key)
}

export function path(paths: Array<string | number>, obj: any, fallbackValue?: any) {
  let val = obj
  let idx = 0
  while (idx < paths.length) {
    if (val == null) {
      return fallbackValue
    }
    val = val[paths[idx]]
    idx += 1
  }
  return !isDef(val) && fallbackValue !== void 0 ? fallbackValue : val
}

export const pick = (object, paths) => paths.reduce((acc, key) => ({ ...acc, [key]: object[key] }), {})

export const merge = (data, newData) =>
  Object.keys(newData).reduce((acc, key) => ({
    ...acc,
    [key]: acc[key]
      ? newData[key] !== undefined
        ? typeof acc[key] === 'object' && typeof newData[key] === 'object'
          ? Array.isArray(acc[key])
            ? [].concat(acc[key], newData[key])
            : merge(acc[key], newData[key])
          : newData[key]
        : acc[key]
      : newData[key]
  }), data)

export function isArray(x) {
  return Array.isArray(x)
}

export function safeConcat(...args) {
  return args.reduce((acc, item) => Boolean(item) ? acc.concat(item) : acc, [])
}

export function escapeRegexp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export async function copyText(value: any = 'nothing') {
  return await navigator.clipboard.writeText(value).then(() => {
    return true
  }, () => {
    return false
  })
}

export function isPlainObject(value: any): boolean {
  if (value == null || typeof value !== 'object') {
    return false
  }

  const proto = getPrototype(value)
  if (proto === null) {
    return true
  }
  const Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor
  return (
    typeof Ctor === 'function'
    && Ctor instanceof Ctor
    && funcToString.call(Ctor) === objectCtorString
  )
}
